import '@/scss/pages/teacher.scss'

import header from '../layout/header'
import publicationsLoadMore from '../section/teacher/load-more'

document.addEventListener('DOMContentLoaded', function () {
  header()
  publicationsLoadMore()
})
